import { render } from "./QuizApp.vue?vue&type=template&id=b7b915fe"
import script from "./QuizApp.vue?vue&type=script&lang=js"
export * from "./QuizApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__